




































































































































































































































































































































































































import { Vue, Component } from "vue-property-decorator";
import { settings, auth } from "@/loader";
import IpRule from "../../component/ip/IpRule.vue";

@Component({
	components: {
		IpRule,
	}
})
export default class Options extends Vue {
	public get canEdit(): boolean {
		return auth.user?.capabilities.manage_valentin_ip || false;
	}

	public get renew_limit(): number {
		return settings.renew_limit;
	}
	public set renew_limit(renew_limit: number) {
		settings.set({ renew_limit });
	}

	public get header(): string {
		return settings.model_header;
	}
	public set header(model_header: string) {
		settings.set({ model_header });
	}

	public get title(): string {
		return settings.model_title;
	}
	public set title(model_title: string) {
		settings.set({ model_title });
	}

	public get price(): string {
		return settings.model_price;
	}
	public set price(model_price: string) {
		settings.set({ model_price });
	}

	public get subcontracting(): string {
		return settings.model_subcontracting;
	}
	public set subcontracting(model_subcontracting: string) {
		settings.set({ model_subcontracting });
	}

	public get conclusion(): string {
		return settings.model_conclusion;
	}
	public set conclusion(model_conclusion: string) {
		settings.set({ model_conclusion });
	}

	public get observations(): string {
		return settings.model_observations;
	}
	public set observations(model_observations: string) {
		settings.set({ model_observations });
	}

	public get specific_materials(): string {
		return settings.model_specific_materials;
	}
	public set specific_materials(model_specific_materials: string) {
		settings.set({ model_specific_materials });
	}

	public get other_means(): string {
		return settings.model_other_means;
	}
	public set other_means(model_other_means: string) {
		settings.set({ model_other_means });
	}

	public get company_name(): string {
		return settings.company_name;
	}
	public set company_name(company_name: string) {
		settings.set({ company_name });
	}

	public get company_address(): string {
		return settings.company_address;
	}
	public set company_address(company_address: string) {
		settings.set({ company_address });
	}

	public get company_zipcode(): string {
		return settings.company_zipcode;
	}
	public set company_zipcode(company_zipcode: string) {
		settings.set({ company_zipcode });
	}

	public get company_city(): string {
		return settings.company_city;
	}
	public set company_city(company_city: string) {
		settings.set({ company_city });
	}

	public get company_tp(): string {
		return settings.company_tp;
	}
	public set company_tp(company_tp: string) {
		settings.set({ company_tp });
	}

	public get company_status(): string {
		return settings.company_status;
	}
	public set company_status(company_status: string) {
		settings.set({ company_status });
	}

	public get company_capital(): string {
		return settings.company_capital;
	}
	public set company_capital(company_capital: string) {
		settings.set({ company_capital });
	}

	public get company_rcs(): string {
		return settings.company_rcs;
	}
	public set company_rcs(company_rcs: string) {
		settings.set({ company_rcs });
	}

	public get company_siren(): string {
		return settings.company_siren;
	}
	public set company_siren(company_siren: string) {
		settings.set({ company_siren });
	}

	public get company_ape(): string {
		return settings.company_ape;
	}
	public set company_ape(company_ape: string) {
		settings.set({ company_ape });
	}

	public get company_phone(): string {
		return settings.company_phone;
	}
	public set company_phone(company_phone: string) {
		settings.set({ company_phone });
	}

	public get company_fax(): string {
		return settings.company_fax;
	}
	public set company_fax(company_fax: string) {
		settings.set({ company_fax });
	}

	public get company_url(): string {
		return settings.company_url;
	}
	public set company_url(company_url: string) {
		settings.set({ company_url });
	}

	public get company_contact(): string {
		return settings.company_contact;
	}
	public set company_contact(company_contact: string) {
		settings.set({ company_contact });
	}

	public get company_email(): string {
		return settings.company_email;
	}
	public set company_email(company_email: string) {
		settings.set({ company_email });
	}

	public get company_sign(): string {
		return settings.company_sign;
	}
	public set company_sign(company_sign: string) {
		settings.set({ company_sign });
	}

	public get company_sign_position(): string {
		return settings.company_sign_position;
	}
	public set company_sign_position(company_sign_position: string) {
		settings.set({ company_sign_position });
	}

	public get company_employees(): number {
		return settings.company_employees;
	}
	public set company_employees(company_employees: number) {
		settings.set({ company_employees })
	}

	public get company_workers(): number {
		return settings.company_workers;
	}
	public set company_workers(company_workers: number) {
		settings.set({ company_workers })
	}

	public get company_clericals(): number {
		return settings.company_clericals;
	}
	public set company_clericals(company_clericals: number) {
		settings.set({ company_clericals })
	}

	public get company_executives(): number {
		return settings.company_executives;
	}
	public set company_executives(company_executives: number) {
		settings.set({ company_executives })
	}

	public get company_design_workers(): number {
		return settings.company_design_workers;
	}
	public set company_design_workers(company_design_workers: number) {
		settings.set({ company_design_workers })
	}

	public get company_lab_workers(): number {
		return settings.company_lab_workers;
	}
	public set company_lab_workers(company_lab_workers: number) {
		settings.set({ company_lab_workers })
	}

	public save() {
		if (!this.company_name || !this.company_address || !this.company_zipcode || !this.company_city || !this.company_status || !this.company_capital || !this.company_siren || !this.company_ape || !this.company_tp || !this.company_employees || !this.company_executives || !this.company_clericals || !this.company_workers) {
			this.$bvToast.toast("Veuillez remplir tous les champs obligatoires.", {
				title: "Erreur",
				variant: "danger",
				autoHideDelay: 5000,
			});
			return;
		}
		settings.save();
	}
}
